import { Link } from "gatsby"
import { Img } from "../layout/Img"

export const SidebarProfiles = ({ profiles }) => {
  return (
    <div>
      <span className="block mt-4 mb-2 text-lg font-light leading-tight uppercase text-primary">Team</span>
      <div className="mt-4">
        <div className="">
          {profiles.map(({ title, profilePicture, uid, uri, profileRole }) => (
            <Link key={uid} className="flex my-4" to={`/${uri}`}>
              <Img
                className="rounded-full w-14 h-14"
                image={profilePicture[0]}
                imgStyle={{ borderRadius: '100%' }}
              />
              <div>
                <h6 className="block mt-1 ml-4 font-bold">{title}</h6>
                <span className="ml-4 text-base">{profileRole}</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  )
}
